import { Box, useStyleConfig, forwardRef } from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

const Card = forwardRef((props, ref) => {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("Card", { variant });

  return (
    <MotionBox
      ref={ref}
      __css={styles}
      initial={{ opacity: 0, y: 30, scale: 0.9, rotate: -5 }} // Added rotation
      animate={{ opacity: 1, y: 0, scale: 1, rotate: 0 }} // Reset rotation
      transition={{
        duration: 1.2, // Slowed down the animation
        ease: "easeOut", // Smooth easing
      }}
      {...rest}
    >
      {children}
    </MotionBox>
  );
});

export default Card;
